import React from "react"
import { RootStore } from "../stores/RootStore"

export const RootStoreContext = React.createContext<RootStore | undefined>(
    undefined
)